import ScalarMenu_vue_vue_type_script_setup_true_lang_default from "./ScalarMenu.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarMenu/ScalarMenu.vue
var ScalarMenu_default = ScalarMenu_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenu_default as default };

//# sourceMappingURL=ScalarMenu.vue.js.map